// src/components/PastDueBillsModal.tsx
import { Modal, Paper, Text, Stack, Group, Button } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { Bill } from '../types';

interface PastDueBillsModalProps {
	opened: boolean;
	onClose: () => void;
	pastDueBills: Bill[];
	onMarkPaid: (billId: string) => void;
}

function PastDueBillsModal({
	opened,
	onClose,
	pastDueBills,
	onMarkPaid,
}: PastDueBillsModalProps) {
	const unpaidBills = pastDueBills.filter((bill) => !bill.paid);
	const totalPastDue = unpaidBills.reduce(
		(sum, bill) => sum + bill.amount,
		0
	);

	return (
		<Modal
			opened={opened}
			onClose={onClose}
			title='Past Due Bills'
			size='lg'
			centered
		>
			<Stack gap='md'>
				{totalPastDue > 0 && (
					<Paper withBorder p='md' radius='md' bg='red.1'>
						<Group wrap='nowrap' gap='xl'>
							<IconAlertCircle size={32} color='red' />
							<div>
								<Text size='lg' fw={700} c='red'>
									Total Past Due: ${totalPastDue.toFixed(2)}
								</Text>
								<Text size='sm' c='red.7'>
									{unpaidBills.length} unpaid bill
									{unpaidBills.length !== 1 ? 's' : ''}
								</Text>
							</div>
						</Group>
					</Paper>
				)}

				{unpaidBills.length === 0 ? (
					<Text ta='center' c='dimmed' py='xl'>
						No past due bills
					</Text>
				) : (
					<Stack gap='sm'>
						{unpaidBills.map((bill) => (
							<Paper key={bill.id} withBorder p='md' radius='md'>
								<Group justify='apart' mb='xs'>
									<div>
										<Text fw={500} size='lg'>
											{bill.name.length >
											(window.innerWidth <= 375 ? 12 : 24)
												? `${bill.name.slice(
														0,
														window.innerWidth <= 375
															? 12
															: 24
												  )}...`
												: bill.name}
										</Text>
										<Text size='sm' c='dimmed'>
											Due:{' '}
											{bill.dueDate
												? new Date(
														bill.dueDate
												  ).toLocaleDateString()
												: 'N/A'}
										</Text>
									</div>
									<Text fw={700} size='xl' c='red'>
										${bill.amount.toFixed(2)}
									</Text>
								</Group>
								<Button
									variant='light'
									color='blue'
									fullWidth
									onClick={() => onMarkPaid(bill.id)}
								>
									Mark as Paid
								</Button>
							</Paper>
						))}
					</Stack>
				)}
			</Stack>
		</Modal>
	);
}

export default PastDueBillsModal;
